import { da } from "date-fns/locale";
import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import useGetMemberDetails from "../../Hooks/member/useGetMemberDetails";
import axios from "axios";
import { Grid } from "@mui/material";
import Loader from "../ui/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { stopSession } from "../../services/interceptors/ApiInterceptor";
import { CommonButton } from "../../Shared/Components/Buttons/CommonButton";
import { clearStorage } from "../../services/storage/SessionStorageService";
import { useDispatch } from "react-redux";
import { adminActions } from "../../redux/slices/adminSlice";
import { financeActions } from "../../redux/slices/financeSlice";
import { loginCognitoActions } from "../../redux/slices/loginSlice";
import { loyaltyPointsActions } from "../../redux/slices/LoyaltyPointsSlice";
import { memberActions } from "../../redux/slices/memberSlice";
import { merchantActions } from "../../redux/slices/merchantSlice";
import { receiptsActions } from "../../redux/slices/recieptsSlice";
import { roleActions } from "../../redux/slices/roleSlice";
import { salesActions } from "../../redux/slices/SalesSlice";
import { shopUserActions } from "../../redux/slices/shopUserSlice";
import { APIConstants } from "../../constants/ApiConstants";

const Redirect = () => {
  // https://suntec-uat-bi.capillarytech.com/admin/redirect?token={{encrypted_token}}&admin_user_email={{email}}&member_email={{encrypt_email}}

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [query, setQuery] = useState("");
  const [userId, setUserId] = useState("");
  const [decryptEmail, setDecryptEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [loaderTwo, setLoaderTwo] = useState(false);

  const [invalidTokenObj, setInvalidTokenObj] = useState({
    invalid: false,
    message: "",
  });

  const [invalidEmail, setInvalidEmail] = useState({
    invalid: false,
    message: "",
  });
  const [userObj, setUserObj] = useState({
    userNotFound: false,
    message: "",
  });

  const [userAccess, setUserAccess] = useState({
    invalid: false,
    message: "",
  });

  const [isLoggedInUser, setIsLoggedInUser] = useState({
    invalid: false,
    message: "",
  });

  const { getMemberDetails, loading } = useGetMemberDetails(userId);

  let token = queryParams.get("token");
  let adminUserEmail = queryParams.get("admin_user_email");
  let memberEmail = queryParams.get("member_email");
  let decodedMemberEmail = memberEmail
    ? decodeURIComponent(memberEmail)?.replace(/\s/g, "+")
    : null;

  

  const loggedInEmail = localStorage.getItem("username");
  console.log(adminUserEmail, "adminUserEmail");

  console.log(loggedInEmail, "loggedInEmail");
  const item = localStorage.getItem("isFromRedirect");
  const isFromRedirect = item ? JSON.parse(item) : null;

  // if (
  //   loggedInEmail &&
  //   loggedInEmail?.length > 0 &&
  //   loggedInEmail !== adminUserEmail
  // ) {
  //   // resetPersistStates();
  //   // clearStorage();
  //   // navigate(`/login`);
  //   sessionStorage.clear();
  //   localStorage.clear();
  //   navigate("/login");
  // }

  if (isFromRedirect) {
    const item = localStorage.getItem("redirect-data");
    const paramsData = item ? JSON.parse(item) : null;

    token = paramsData?.token;
    adminUserEmail = paramsData?.adminUserEmail;
    decodedMemberEmail = paramsData?.decodedMemberEmail;
  }

  //   localStorage.setItem(
  //     "redirect-data",
  //     JSON.stringify({ token, adminUserEmail, memberEmail })
  //   );
  //   localStorage.setItem("isFromRedirect", JSON.stringify(true));

  const decryptEmailApi = async () => {
    setIsLoading(true);
    const body: any = {
      adminEmail: adminUserEmail,
      encryptedEmail: decodedMemberEmail,
    };

    try {
      const data = await fetch(

        `${process.env.REACT_APP_HUBSPOT_URL + APIConstants.hubspotDecryptText}`, 
        // "https://zq26ej9cj5.execute-api.ap-southeast-1.amazonaws.com/Uat/hubspot/decrypt-text",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Cap-Suntec-Auth-Token": token + "",
            "implementation-id": "sg-suntec-city",
          },
          body: JSON.stringify(body),
        }
      );

      const result = await data.json();

      if (result?.status) {
        localStorage.setItem("fromUrl", JSON.stringify(true));

        if (result?.data?.decryptedEmail) {
          setDecryptEmail(result?.data?.decryptedEmail);
        } else {
          setDecryptEmail(result?.data?.decryptedText);
        }
      } else if (
        result.hasOwnProperty("error_type") &&
        result?.error_type === "access error"
      ) {
        toast.error(result?.message);

        setInvalidTokenObj({
          invalid: true,
          message: result?.message,
        });

        // setTimeout(() => {
        //   sessionStorage.clear();
        //   stopSession();
        //   localStorage.clear();
        //   navigate("/login", { replace: true });
        // }, 1500);
      } else if (result?.statusCode === 404) {
        toast.error(result?.message);

        setInvalidTokenObj({
          invalid: true,
          message: result?.message,
        });
        // setTimeout(() => {
        //   sessionStorage.clear();
        //   stopSession();
        //   localStorage.clear();
        //   navigate("/login", { replace: true });
        // }, 1500);
      } else if (result?.statusCode === 400) {
        setInvalidEmail({
          invalid: true,
          message: result?.message,
        });
      } else if (!result?.status) {
        toast.error(result?.message);

        setInvalidTokenObj({
          invalid: true,
          message: result?.message,
        });
      }
    } catch (e: any) {
      console.log(e, "error");
    } finally {
      setIsLoading(false);
    }
  };

  const getCustomerId = async (ele: string) => {
    setLoaderTwo(true);
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + `member/search?query=${ele}`
      );

      if (response?.data?.count > 0) {
        getMemberDetails(response?.data?.value[0]?.userId);
      } else {
        toast.warn("Member not found", { autoClose: false });
        setUserObj({
          userNotFound: true,
          message: "Member not found",
        });
      }
    } catch (error: any) {
      console.error("error", error);
      if (
        error?.response?.status === 403 &&
        error?.response?.data?.error?.length > 0
      ) {
        setUserAccess({
          invalid: true,
          message: error?.response?.data?.error,
        });
      } else if (error?.message === "Network Error") {
        localStorage.clear();
        localStorage.setItem(
          "redirect-data",
          JSON.stringify({ token, adminUserEmail, decodedMemberEmail })
        );
        localStorage.setItem("isFromRedirect", JSON.stringify(true));
        navigate("/login");
      }
    } finally {
      setLoaderTwo(false);
    }
  };

  const resetPersistStates = () => {
    dispatch(adminActions.resetAdminState());
    dispatch(financeActions.resetFinanceReset());
    dispatch(loginCognitoActions.resetLoginState());
    dispatch(loyaltyPointsActions.resetLoyaltyState());
    dispatch(memberActions.resetMemberSlice());
    dispatch(merchantActions.resetMerchantSlice());
    dispatch(receiptsActions.resetReceiptsState());
    dispatch(roleActions.resetRoleSlice());
    dispatch(salesActions.resetSalesSlice());
    dispatch(shopUserActions.resetShopUserSlice());
  };
  const HandleSignOut = async () => {
    try {
      const logoutWindow = window.open(
        "https://sgcrm.cc.capillarytech.com/arya/api/v1/auth/logout",
        "_blank"
      );

      if (logoutWindow) {
        setTimeout(() => {
          logoutWindow.close();
        }, 1);
      } else {
        console.error("Error: Unable to open logout window");
      }
    } catch (err) {
      console.error("Error while initiating logout:", err);
    } finally {
    }
  };

  const handleLogout = async () => {
    HandleSignOut();
    resetPersistStates();
    HandleSignOut();
    setTimeout(() => {
      sessionStorage.clear();
      localStorage.clear();
      navigate("/login");
    }, 1000);
  };

  useEffect(() => {
    if (
      loggedInEmail &&
      loggedInEmail?.length > 0 &&
      loggedInEmail !== adminUserEmail
    ) {
      toast.error("Please login with same admin user email");

      setIsLoggedInUser({
        invalid: true,
        message: "Please login with same",
      });
    } else {
      decryptEmailApi();
    }
  }, []);

  useEffect(() => {
    if (decryptEmail?.length > 0) {
      getCustomerId(decryptEmail);
    }
  }, [decryptEmail]);

  return (
    <div>
      {isLoading || loaderTwo || loading ? (
        <Grid
          item
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="300px"
          width={"100%"}
        >
          <Loader />
        </Grid>
      ) : null}

      {invalidTokenObj?.invalid ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h2>{invalidTokenObj?.message}</h2>
          </div>
        </>
      ) : null}
      {invalidEmail?.invalid ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h2>{invalidEmail?.message}</h2>
          </div>
        </>
      ) : null}

      {userAccess?.invalid ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h2>{userAccess?.message}</h2>
          </div>
        </>
      ) : null}

      {userObj?.userNotFound ||
      invalidTokenObj?.message.trim() === "Invalid data" ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "300px",
              //   width:
            }}
          >
            <h2></h2>

            {/* <Grid item display={"flex"}> */}
            <CommonButton
              variant="contained"
              color="secondary"
              buttonTitle="Back to portal"
              onClick={() => {
                navigate("/members");
              }}
            />
            {/* </Grid> */}
          </div>

          {/* <button
            onClick={() => {
              navigate("/members");
            }}
          >
            Go to portal
          </button> */}
        </>
      ) : null}

      {isLoggedInUser?.invalid ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "300px",
              //   width:
            }}
          >
            <h2></h2>

            {/* <Grid item display={"flex"}> */}
            <CommonButton
              variant="contained"
              color="secondary"
              buttonTitle="Back to login"
              onClick={() => {
                handleLogout();
              }}
            />
            {/* </Grid> */}
          </div>

          {/* <button
            onClick={() => {
              navigate("/members");
            }}
          >
            Go to portal
          </button> */}
        </>
      ) : null}

      <ToastContainer />
    </div>
  );
};

export default Redirect;
